import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { SocketActions } from '@store/socketSaga'
import * as ActionTypes from '@storeOld/actions'
import { call, put, select } from 'redux-saga/effects'

import API from '@/api'
import type { CommentsActions } from '../actions'
import type { UpdatePayload } from '../types'

type UpdateCb = (arg: UpdatePayload & { projectId: ID }) => Promise<void>

export function* update({
  payload: { id, content },
}: ReturnType<typeof CommentsActions.update>) {
  const projectId: ID = yield select(migrationProjectSelector.getProjectId)

  yield put({
    type: ActionTypes.UPDATE_COMMENT,
    payload: { id, content, updatedAt: Date.now() },
  })

  const response: UpdatePayload = yield call(API.Comments.update as UpdateCb, {
    projectId,
    id,
    content,
  })

  const reducerAction = {
    type: ActionTypes.UPDATE_COMMENT,
    payload: response,
  }

  yield put(
    SocketActions.emit({
      eventName: 'comments',
      payload: reducerAction,
    })
  )
}
